import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AbstractBaseListComponent } from '../../../../components/base/abstract-base-list-component';
import { BaseSetupModel } from '../model/base-setup-model';
import { AclClassConstants } from '../../../aclClassConstants';
import { AclConstants } from '../../../aclOperationConstants';
import { MatTableDataSource } from '@angular/material';
import { TableKeyEnum } from '../../../../core/enum/table-key.enum';
import { SearchControlTypeEnum, SearchDataTypeEnum } from '../../../../core/enum/searchType.enum';
import { PaginationData } from '../../../../core/modal/pagination-data';
import { Subscription } from 'rxjs';
import { LoginService } from '../../../login/login.service';
import { ToastrService } from 'ngx-toastr';
import { SearchService } from '../../../../services/search.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { BaseSetupService } from '../service/base-setup.service';
import { IBaseService } from '../../../../services/ibase-service';

@Component({
  selector: 'app-base-setup-list',
  templateUrl: './base-setup-list.component.html',
  styleUrls: ['./base-setup-list.component.scss']
})
export class BaseSetupListComponent extends AbstractBaseListComponent<BaseSetupModel> implements OnInit {
  @ViewChild("actionBtn", { static: false }) actionBtnReff: TemplateRef<any>;
  @ViewChild("totalproperties", { static: false }) totalpropertiesReff: TemplateRef<any>;
  @ViewChild("totalcircuit", { static: false }) totalcircuitReff: TemplateRef<any>;
  @ViewChild ('editBaseSetupModelName',{static:false}) BaseSetupModelNameRef:TemplateRef<any>;

  AclClassConstants = AclClassConstants;
  AclConstants = AclConstants;
  basesetupneogridsetting: any = {};
  dataList: any[] = [];
  dataSource = new MatTableDataSource([]);
  dataGrid: any[] = [];
  tableKeyenum: any = TableKeyEnum;
  searchSettings: any = {};
  allColumns: any[] = [];
  subscriptions: Subscription[] = [];
  loginService: LoginService;
  circuitlist: any;
  constructor(
    private toaster: ToastrService,
    private searchSevice: SearchService,
    private baseSetupService: BaseSetupService,

    private ngbModalService: NgbModal,
    private router: Router,
    loginService: LoginService
  ) {
    super(toaster, searchSevice)
    this.loginService = loginService;
  }
  ngOnInit() {
    this.setDefaultPageSize(this.tableKeyenum.BASE_SETUP_LIST)
    this.init();
    this.getTableColumn();

    const filterSubscription = this.searchSevice.getFilterOptions().subscribe((obj) => {

      // if (obj && obj.filters) {
     // this.applyFilter(obj);
      // }else
    });
    this.subscriptions.push(filterSubscription);
  }


  // applyFilter(filterObj) {
  //   let filteredDataForGrid = JSON.parse(JSON.stringify(this.dataGrid));
  //   if (filterObj && filteredDataForGrid) {
  //     this.baseSetupService.getAdvanceFilterSearchData(filterObj).subscribe((res) => {
  //       this.refreshDataSource(res.dataList);
  //       this.neoTableSetting.pageTotalLength = res.totalRecords;
  //     });
  //   }
  // }
  
  getService(): IBaseService<BaseSetupModel> {
    return this.baseSetupService;
  }
  setList(list: any) {
    this.dataGrid = list;
    this.basesetupneogridsetting.pageTotalLength = this.totalRecords;
    this.refreshDataSource(this.dataGrid);
  }
  getTableColumn() {
    let self = this;

    this.allColumns = [
      {
        colKey: 'index',
        default: 'ID',
        rowKey: 'id',
        width: '1%',
        isFilterAllow: false,
        isNumber: true,
      },
      {
        colKey: 'name',
        default: 'Base Name',
        rowKey: 'name',
        width: '10%',
        isNumber: false,
        isFilterAllow: true,
        enableEdit: true,
        enableDelete: true,
        enableSort: true,
      },
      {
        colKey: 'address',
        default: 'Address',
        rowKey: 'address',
        width: '10%',
        isNumber: false,
        isFilterAllow: true,
        enableEdit: true,
        enableDelete: true,
        enableSort: true,
      },
      {
        colKey: 'propertyType',
        default: 'Property Type',
        rowKey: 'propertyType',
        width: '10%',
        isNumber: false,
        isFilterAllow: true,
        enableEdit: true,
        enableDelete: true,
        enableSort: true,
      },
      {
        colKey: 'rentAmount',
        default: 'Rent Amount',
        rowKey: 'rentAmount',
        width: '10%',
        isNumber: false,
        isFilterAllow: true,
        enableEdit: true,
        enableDelete: true,
        enableSort: true,
      },
      {
        colKey: 'url',
        default: 'Url',
        rowKey: 'url',
        width: '10%',
        isNumber: false,
        isFilterAllow: true,
        enableEdit: true,
        enableDelete: true,
        enableSort: true,
      },
      {
        colKey: 'installationDateString',
        default: 'Installation Date',
        rowKey: 'installationDateString',
        width: '10%',
        isNumber: false,
        isFilterAllow: true,
        enableEdit: true,
        enableDelete: true,
        enableSort: true,
      },
      {
        colKey: 'contactperson',
        default: 'Contact Person',
        rowKey: 'contactperson',
        width: '10%',
        isNumber: false,
        isFilterAllow: true,
        enableEdit: true,
        enableDelete: true,
        enableSort: true,
      },
      {
        colKey: 'contactnumber',
        default: 'Contact Number',
        rowKey: 'contactnumber',
        width: '10%',
        isNumber: false,
        isFilterAllow: true,
        enableEdit: true,
        enableDelete: true,
        enableSort: true,
      },
      {
        colKey: 'actionCol',
        default: 'Action',
        rowKey: 'id',
        //enableEdit: true,
        // enableDelete: true,
        enableEdit: false,
        enableDelete: false,
        isFilterAllow: false,
        enableSort: false,
        isExpandable: false,
        isNumber: false,
        width: '1%',
        isStickyEnd: true,
      },
    ];
    this.allColumns.forEach(element => {
      element.isFilterAllow = false;
    });
    this.getTableSetting();
    this.getTableSearchSetting();
  }
  getTableSetting() {

    let basesetupneogridsetting = {
      showAdvanceSearch: false,
      showFooter: false,
      showPagination: true,
      tableId: this.tableKeyenum.BASE_SETUP_LIST,
      perPage: this.paginationData.rowsPerPage,
      pageNumber:this.paginationData.pageNumber - 1,
      pageSizeOptions: [5, 10, 15, 20, 50, 100],
      sort: true,
      serverSideSortPagination: true,
      pageTotalLength: 0,
      serverSideFilter: true,
      //defaultSortCol: '',
      //defaultSortDirection: 'desc',
      // enableMultiDelete: true,
      columns: this.allColumns,
      deleteMsgBoxTitle: 'Are you sure to delete this Record ?',
      deleteMsgBoxDetail: 'Base Name :${name} ',
    };
    this.basesetupneogridsetting = basesetupneogridsetting
    return basesetupneogridsetting
  }
  getTableSearchSetting() {
    this.searchSettings = [
      {
        display_field: 'Name',
        value_field: 'name',
        control_setting: [
          {
            control_type: SearchControlTypeEnum.TEXT,
            display_style: '',
          },
        ],
        data_type: SearchDataTypeEnum.STRING,
      },
      {
        display_field: 'STATUS',
        value_field: 'status',
        control_setting: [
          {
            control_type: SearchControlTypeEnum.TEXT,
            display_style: '',
          },
        ],
        data_type: SearchDataTypeEnum.STRING,
      },
    ];
  }

  public onDeleteClick(event: BaseSetupModel) {
    if (event) {
      this.commonDeleteMsgBox(this.basesetupneogridsetting, event, this.afterDeleteConfirm.bind(this));
    }
  }
  public onEditClick(event: BaseSetupModel) {
    this.setUpdateValueInForm(event);
  }
  setUpdateValueInForm(rowData) {
    this.router.navigate(['/network-management/base-setup/', rowData.id]);
  }
  refreshDataSource(data) {
    if (data) {
      this.dataSource = new MatTableDataSource(JSON.parse(JSON.stringify(data)));
    }else{
      this.dataSource = new MatTableDataSource();
    }
  }
  onAddClick() {
    this.router.navigate(['/network-management/base-setup']);
  }
  afterDeleteConfirm(objEvent) {
    if (objEvent.deleteClicked) {
      this.delete(objEvent.event);

    }
  }
  ngAfterViewInit() {
    this.allColumns.forEach((col) => {
      if (col.colKey == 'actionCol') {
        col.customControls = [this.actionBtnReff];
      }
      if(col.colKey=='name'){
        col.customControls=[this.BaseSetupModelNameRef]

      }
    });
  }
  onPageChange(event) {
    let paginationData = new PaginationData();
    paginationData = event;
    this.onPaginationChange(paginationData);
  }

 
} 
